import React, { useMemo } from "react";
import { Box } from "@mui/material";

/**
 * Pliega un carácter para comparar sin acentos ni mayúsculas ("Á" -> "a").
 * Se hace carácter por carácter para que el texto plegado conserve la misma
 * longitud que el original y los índices del match sigan siendo válidos.
 */
const foldChar = (char) =>
  char.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() ||
  char.toLowerCase();

const fold = (text) => Array.from(text).map(foldChar).join("");

/** Resalta las coincidencias de `query` dentro de `text`. */
export const HighlightText = ({ text = "", query = "" }) => {
  const parts = useMemo(() => {
    const term = query.trim();
    if (!text || !term) return [{ value: text, match: false }];

    const foldedText = fold(text);
    const foldedTerm = fold(term);

    // Si el plegado cambió la longitud (caracteres raros) no se puede mapear
    // el match al texto original: se muestra sin resaltar.
    if (foldedText.length !== text.length) return [{ value: text, match: false }];

    const segments = [];
    let cursor = 0;
    let index = foldedText.indexOf(foldedTerm);

    while (index !== -1) {
      if (index > cursor) {
        segments.push({ value: text.slice(cursor, index), match: false });
      }
      segments.push({
        value: text.slice(index, index + foldedTerm.length),
        match: true,
      });
      cursor = index + foldedTerm.length;
      index = foldedText.indexOf(foldedTerm, cursor);
    }

    if (cursor < text.length) {
      segments.push({ value: text.slice(cursor), match: false });
    }

    return segments;
  }, [text, query]);

  return (
    <>
      {parts.map((part, idx) =>
        part.match ? (
          <Box key={idx} component="mark" sx={{ bgcolor: "transparent", fontWeight: 700, color: "inherit" }}>
            {part.value}
          </Box>
        ) : (
          <React.Fragment key={idx}>{part.value}</React.Fragment>
        )
      )}
    </>
  );
};
